<!-- whatsapp.component.html -->
<mat-card>
  <mat-card-header>
    <mat-card-title>Send WhatsApp Message</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="messageForm" (ngSubmit)="sendMessage()">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Phone Number</mat-label>
        <input matInput formControlName="phoneNumber" placeholder="e.g., +919422919898">
        <mat-error *ngIf="messageForm.get('phoneNumber')?.hasError('required')">
          Phone number is required
        </mat-error>
      </mat-form-field>

      <mat-radio-group formControlName="messageType" class="full-width">
        <mat-radio-button value="template">Template Message</mat-radio-button>
        <mat-radio-button value="custom">Custom Message</mat-radio-button>
      </mat-radio-group>

      <ng-container *ngIf="messageForm.get('messageType')?.value === 'template'">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Date</mat-label>
          <input matInput formControlName="date" placeholder="e.g., 12/1">
          <mat-error *ngIf="messageForm.get('date')?.hasError('required')">
            Date is required for template message
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Time</mat-label>
          <input matInput formControlName="time" placeholder="e.g., 3pm">
          <mat-error *ngIf="messageForm.get('time')?.hasError('required')">
            Time is required for template message
          </mat-error>
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="messageForm.get('messageType')?.value === 'custom'">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Custom Message</mat-label>
          <textarea matInput formControlName="customMessage"
                    placeholder="Enter your message here" rows="4"></textarea>
          <mat-error *ngIf="messageForm.get('customMessage')?.hasError('required')">
            Message is required
          </mat-error>
        </mat-form-field>
      </ng-container>

      <button mat-raised-button color="primary" type="submit"
              [disabled]="messageForm.invalid || sending">
        {{ sending ? 'Sending...' : 'Send Message' }}
      </button>
    </form>
  </mat-card-content>
</mat-card>
